import { useCallback } from "react";

import type {
  AccommodationFacilityType,
  ArchitectureTypeSeries,
  ArchitectureTypeSize,
} from "../../../../../../../__generated__/gql/graphql";

export {
  architectureFilterItems,
  ARCHITECTURE_LARGE_VALUE,
  isLargeFilter,
} from "./use-architecture-type-filter";
export { facilityFilterItems } from "./use-facility-filter";
export { useAreaFilter } from "./use-area-filter";

import { useArchitectureTypeFilter } from "./use-architecture-type-filter";
import { useFacilityFilter } from "./use-facility-filter";

/**
 * 室単位のフィルターを管理・生成するHook
 * 施設フィルタと建築タイプフィルタを統合している
 */
export function useAccommodationFilter() {
  const { facilityFilter, setFacilityFilter, matchesFacilityFilter } =
    useFacilityFilter();
  const {
    architectureFilter,
    setArchitectureFilter,
    matchesArchitectureFilter,
  } = useArchitectureTypeFilter();

  const hasAccommodationFilter =
    facilityFilter.size > 0 || architectureFilter.size > 0;

  const matchesAccommodationFilter = useCallback(
    (accommodation: {
      facilityTypes: AccommodationFacilityType[];
      architectureType: {
        series: ArchitectureTypeSeries;
        seriesShortName: string;
        size?: ArchitectureTypeSize | null;
      };
    }) =>
      matchesFacilityFilter(accommodation.facilityTypes) &&
      matchesArchitectureFilter(accommodation.architectureType),
    [matchesFacilityFilter, matchesArchitectureFilter],
  );

  return {
    facilityFilter,
    setFacilityFilter,
    architectureFilter,
    setArchitectureFilter,
    hasAccommodationFilter,
    matchesAccommodationFilter,
  };
}
